export const isIE = () => {
  if (typeof window !== 'undefined') {
    const ua = window.navigator && window.navigator.userAgent;
    return ua && (ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1);
  }
};
